import React from "react";

import type { JSX } from "react";

import type {
  OVPBroadcast,
  ScheduleBroadcast,
} from "../../../api/FastAPI.types";

interface ContentTooltipScheduleProps {
  title: string;
  framerate: number;
  broadcasts: (ScheduleBroadcast | OVPBroadcast)[];
}

function ContentTooltipSchedule({
  title,
  framerate,
  broadcasts,
}: ContentTooltipScheduleProps): JSX.Element {
  return (
    <div className="flex h-auto w-full flex-col text-left leading-none">
      <span className="text-center font-semibold">
        {`${title} - ${framerate} FPS`}
      </span>
      {Boolean(broadcasts?.length !== 0) && (
        <div className="mt-[0.625rem] flex flex-col gap-[0.625rem]">
          {broadcasts.map((broadcast) => (
            <div
              key={broadcast.uuid}
              className="flex flex-row justify-start gap-[0.46875rem] align-middle"
            >
              <div
                className="size-[1.40625rem] rounded-[0.234375rem] bg-contain bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${broadcast.broadcaster_logo_url})`,
                }}
              />
              <span className="my-auto">{broadcast.broadcaster_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContentTooltipSchedule;
